import React, {useContext, useEffect, useState} from "react";
import {ReactComponent as LoginIcon} from "../../images/login_blue.svg";
import { DEFAULT_LOGIN_METHODS, PLATFORM_SETTINGS, TEXTBOX, USER_SETTINGS, DEFAULT_ATTENDANCE_SAVED_LOCATIONS, LOGIN_METHODS, YUJA_DROPDOWN_SIZE } from "../../utils/constants";
import {checkAllEmpty, notifyError, notifySuccess} from "../../utils/helpers";
import classes from "./Settings.module.css";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {ReactComponent as AttendanceDetailsIcon} from "../../images/attendance_details.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import SavedLocationsModal from "../../components/modals/SavedLocationsModal";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import useHostResource from "../../hooks/useHostResource";
import OverrideModal from "../../components/modals/OverrideModal";
import {ReactComponent as API_ICON} from "../../images/apiAccessIcon.svg";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {YuJaGlobalState} from "../../utils/LoadingContext";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import { useTranslation } from "react-i18next";



export default function PlatformSettingTab({
                                               platformSettings,
                                               setPlatformSettings,
                                               loading=false,
                                               setLoading,
}) {
    const { t } = useTranslation();
    const {globalHostResource: hostResource} = useContext(YuJaGlobalState);
    const {updatePlatformSetting} = useHostResource(window.location.hostname);
    const {updateSetting} = InstitutionApiCalls();
    const [, setLMSAttemptSetting] = useState("");
    const [showADFS, setShowADFS] = useState(false);
    const [showSHIBBOLETH, setShowSHIBBOLETH] = useState(false);
    const [showDCAM, setShowDCAM] = useState(false);
    const [showGOOGLE, setShowGOOGLE] = useState(false);
    const [showAZURE, setShowAZURE] = useState(false);

    const [showSavedLocationModal, setShowSavedLocationModal] = useState(false);
    const [savedLocations, setSavedLocations] = useState([]);
    const [openOverride, setOpenOverride] = useState(false);

    const standaloneLoginEnabled =  !platformSettings.hasOwnProperty(PLATFORM_SETTINGS.YUJA_LOGIN) || !JSON.parse(platformSettings[PLATFORM_SETTINGS.YUJA_LOGIN]);

    // if (name === LOGIN_METHODS.YUJA) {
    //     return YUJA_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.ADFS) {
    //     return ADFS_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.SHIBBOLETH) {
    //     return SHIBBOLETH_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.DCAM) {
    //     return DCAM_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.GOOGLE) {
    //     return GOOGLE_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.AZURE) {
    //     return AZURE_LOGIN_OPTION_TITLE;
    // }

    const LOGIN_METHODS_OPTIONS = [
        {label: t("auth.loginOptionYuja"), value: DEFAULT_LOGIN_METHODS.YUJA_LOGIN},
        {label: t("auth.loginOptionAdfs"), value: DEFAULT_LOGIN_METHODS.SSONAME_ADFS},
        {label: t("auth.loginOptionShibboleth"), value: DEFAULT_LOGIN_METHODS.SSONAME_SHI},
        {label: t("auth.loginOptionDcam"), value: DEFAULT_LOGIN_METHODS.SSONAME_DCAM},
        {label: t("auth.loginOptionGoogle"), value: DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE},
        {label: t("auth.loginOptionAzure"), value: DEFAULT_LOGIN_METHODS.SSONAME_AZURE},

    ];

    useEffect(() => {
        console.log(`platformSettings changed: ${JSON.stringify(platformSettings)}`);
        setSavedLocations(JSON.parse(platformSettings && platformSettings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS)
            ? platformSettings[USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS]
            : DEFAULT_ATTENDANCE_SAVED_LOCATIONS)
        );
    }, [platformSettings]);


    useEffect(() => {
        const {platformSetting, ssoConfig={}} = hostResource;
        if (platformSetting && platformSetting.hasOwnProperty(PLATFORM_SETTINGS.LMS_QUIZ_ATTEMPTS)) {
            const LMSQuizAttempts = platformSetting[PLATFORM_SETTINGS.LMS_QUIZ_ATTEMPTS];
            setLMSAttemptSetting(LMSQuizAttempts);
        }
        if(ssoConfig.ADFS && !checkAllEmpty(ssoConfig.ADFS)) {
          setShowADFS(true);
        }
        if(ssoConfig.SHIBBOLETH && !checkAllEmpty(ssoConfig.SHIBBOLETH)) {
          setShowSHIBBOLETH(true);
        }
        if(ssoConfig.DCAM && !checkAllEmpty(ssoConfig.DCAM)) {
          setShowDCAM(true);
        }
        if(ssoConfig.GOOGLE && !checkAllEmpty(ssoConfig.GOOGLE)) {
          setShowGOOGLE(true);
        }
        if(ssoConfig.AZURE && !checkAllEmpty(ssoConfig.AZURE)) {
          setShowAZURE(true);
        }
    } , [hostResource]) 


    useEffect(() => {
        if (!platformSettings) {
            return; 
        }
        var replaced = false; 
        if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_ADFS && showADFS === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_SHI && showSHIBBOLETH === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_DCAM && showDCAM === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE && showGOOGLE === false) {
            replaced = true;
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_AZURE && showAZURE == false) {
            replaced = true; 
        }

        if (replaced) {
            const copy = JSON.parse(JSON.stringify(platformSettings));
            copy[PLATFORM_SETTINGS.DEFAULT] = "1";
            setPlatformSettings(copy);
        }
    }, [showADFS, showSHIBBOLETH, showDCAM, showGOOGLE, showAZURE, platformSettings]);

    const handlePwdResetChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.PWD_RESET] = input.checked.toString();
        setPlatformSettings(copy);
    };

    const handleYujaLoginNameChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.YUJA_NAME] = input.value;
        setPlatformSettings(copy);
    }; 

    const handleSSONameChangeADFS = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_ADFS] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONameChangeSHI = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_SHI] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONameChangeDCAM = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_DCAM] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONAMEChangeGOOGLE = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_GOOGLE] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONAMEChangeAZURE = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_AZURE] = input.value;
        setPlatformSettings(copy);
    }

    const handleDefaultChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.DEFAULT] = input.value;
        setPlatformSettings(copy);
    }

    const changeDefaultLoginMethod = (option) => {
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.DEFAULT] = option.value;
        setPlatformSettings(copy);
    }

    const savePlatformSettings = (settings) => {
        setLoading(true);
        Promise.all([updateSetting(settings), updatePlatformSetting(settings)])
            .then(() => {
                notifySuccess(t("settings.saveSuccess"));
            }).finally(() => {
                setLoading(false)
            });
    };


    const overwriteModalConfig = {
        title: t("integration.guide.commonAddAccessKeyButtonText"),
        okText: t("common.override"),
        cancelText: t("common.cancel"),
        desc: t("integration.guide.commonAddAccessKeyModalDescription"),
        okDisabled: true,
        submit: async (val) => {
            const copy = JSON.parse(JSON.stringify(platformSettings));
            copy[PLATFORM_SETTINGS.PRIVATE_EVP_API_TOKEN] = val;
            setPlatformSettings(copy);
            setOpenOverride(false);
        },
        close:  async () => {
            setOpenOverride(false);
        },
    };

    return (
        <>
            <SavedLocationsModal
                show={showSavedLocationModal}
                setShow={setShowSavedLocationModal}
                savedLocations={savedLocations}
                setSavedLocations={setSavedLocations}
                userSettings={platformSettings}
                setUserSettings={setPlatformSettings}
                saveSettingsCallback={savePlatformSettings}
                description={t("institution.savedLocationsModalDescription")}
            />

            <div className={classes.cardBox} style={{minWidth: 500, flex: 1}}>
                <div className={classes.cardBoxHeader}>
                    <LoginIcon  style={{width: 24, height: 24}}/>
                    <span>{t("institution.loginSettingsTitle")}</span>
                </div>
                <div className={classes.cardBoxBody}>
                    {!loading &&
                        <>
                            <div className={classes.cardDescription}>
                                {t("institution.loginSettingsDescription")}
                            </div>
                            <div className={classes.loginMethodsGridLayout}>
                                {/*<div tabIndex={0} role={TEXTBOX} className={styles.titleText}>Enterprise Login</div>*/}
                                {/*<div/>*/}

                                <div>
                                    <div className={classes.settingLabel}>{t("auth.loginOptionYuja")}</div>
                                    <div className={classes.settingDescription}>{t("institution.loginOptionDescriptionYuja")}</div>
                                </div>
                                <YuJaTextBox
                                    placeholder={t("institution.loginOptionPlaceholderYuja")}
                                    containerStyle={{fontSize: 14, lineHeight: 1.6,}}
                                    disabled={platformSettings[PLATFORM_SETTINGS.YUJA_LOGIN] === "true"}
                                    type="text"
                                    value={platformSettings[PLATFORM_SETTINGS.YUJA_NAME]}
                                    onChange={handleYujaLoginNameChange}
                                />

                                {showADFS &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{t("auth.loginOptionAdfs")}</div>
                                            <div className={classes.settingDescription}>{t("institution.loginOptionDescriptionAdfs")}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={t("institution.loginOptionPlaceholderAdfs")}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_ADFS]}
                                            onChange={handleSSONameChangeADFS}
                                        />

                                    </>
                                }


                                {showSHIBBOLETH &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{t("auth.loginOptionShibboleth")}</div>
                                            <div
                                                className={classes.settingDescription}>{t("institution.loginOptionDescriptionShibboleth")}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={t("institution.loginOptionPlaceholderShibboleth")}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_SHI]}
                                            onChange={handleSSONameChangeSHI}
                                        />
                                    </>
                                }

                                {showDCAM &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{t("auth.loginOptionDcam")}</div>
                                            <div className={classes.settingDescription}>{t("institution.loginOptionDescriptionDcam")}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={t("institution.loginOptionPlaceholderDcam")}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_DCAM]}
                                            onChange={handleSSONameChangeDCAM}
                                        />
                                    </>
                                }

                                {showGOOGLE &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{t("auth.loginOptionGoogle")}</div>
                                            <div
                                                className={classes.settingDescription}>{t("institution.loginOptionDescriptionGoogle")}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={t("institution.loginOptionPlaceholderGoogle")}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_GOOGLE]}
                                            onChange={handleSSONAMEChangeGOOGLE}
                                        />
                                    </>
                                }

                                {showAZURE &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{t("auth.loginOptionAzure")}</div>
                                            <div
                                                className={classes.settingDescription}>{t("institution.loginOptionDescriptionAzure")}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={t("institution.loginOptionPlaceholderAzure")}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_AZURE]}
                                            onChange={handleSSONAMEChangeAZURE}
                                        />
                                    </>
                                }
                            </div>
                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{t("institution.defaultLoginOptionTitle")}</div>
                                    <div className={classes.settingDescription}>{t("institution.defaultLoginOptionDescription")}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaDropdown
                                    style={{width: 240}}
                                    data={
                                        LOGIN_METHODS_OPTIONS
                                            .filter(i => !(!standaloneLoginEnabled && i.value === DEFAULT_LOGIN_METHODS.YUJA_LOGIN))
                                            .filter(i => !(!showADFS && i.value === DEFAULT_LOGIN_METHODS.SSONAME_ADFS))
                                            .filter(i => !(!showSHIBBOLETH && i.value === DEFAULT_LOGIN_METHODS.SSONAME_SHI))
                                            .filter(i => !(!showDCAM && i.value === DEFAULT_LOGIN_METHODS.SSONAME_DCAM))
                                            .filter(i => !(!showGOOGLE && i.value === DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE))
                                            .filter(i => !(!showAZURE && i.value === DEFAULT_LOGIN_METHODS.SSONAME_AZURE))
                                    }
                                    onChange={changeDefaultLoginMethod}
                                    size={YUJA_DROPDOWN_SIZE.SMALL}
                                    value={platformSettings[PLATFORM_SETTINGS.DEFAULT]}
                                />
                            </div>


                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{t("institution.engageLoginCredentials")}</div>
                                    <div className={classes.settingDescription}>{t("institution.engageLoginCredentialsDescription")}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={t("institution.engageLoginCredentials")}
                                    checked={standaloneLoginEnabled}
                                    onChange={checked => {
                                        if (!showADFS && !showSHIBBOLETH && !showDCAM && !showGOOGLE && !showAZURE) {
                                            notifyError(t("institution.loginSettingsErrorMsg"))
                                            return;
                                        }
                                        const copy = JSON.parse(JSON.stringify(platformSettings));
                                        if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.YUJA_LOGIN && !checked) {
                                            if (showADFS) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_ADFS;
                                            } else if (showSHIBBOLETH) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_SHI;
                                            } else if (showDCAM) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_DCAM;
                                            } else if (showGOOGLE) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE;
                                            } else if (showAZURE) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_AZURE;
                                            }

                                        }
                                        copy[PLATFORM_SETTINGS.YUJA_LOGIN] = (!checked).toString();
                                        setPlatformSettings(copy);
                                    }}
                                />
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{t("institution.pwdExpiryTitle")}</div>
                                    <div className={classes.settingDescription}>{t("institution.pwdExpiryLabel")}</div>
                                </div>
                                <div style={{flex: 1}}/>

                                <YuJaSwitch
                                    aria-label={t("institution.pwdExpiryTitle")}
                                    checked={platformSettings[PLATFORM_SETTINGS.PWD_RESET] === "true"}
                                    onChange={checked => {
                                        const copy = JSON.parse(JSON.stringify(platformSettings));
                                        copy[PLATFORM_SETTINGS.PWD_RESET] = checked.toString();
                                        setPlatformSettings(copy);
                                    }}
                                />
                            </div>



                        </>
                    }

                    {loading &&
                        <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <div style={{flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={21} width={160} inline={true} borderRadius={10}/>
                                    </div>
                                    <div style={{flex: 5}}>
                                    </div>
                                    <div style={{ flex: 3, display: "flex", justifyContent: "center" }}>
                                        <Skeleton height={21} width={50} inline={true} borderRadius={10} />
                                    </div>
                                </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={19} width={90}  inline={true} borderRadius={10} />
                                    </div>
                                    <div style={{ flex: 5 }}>
                                        <Skeleton height={37} inline={true} borderRadius={10} />
                                    </div>
                                    <div style={{ flex: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true} />
                                    </div>
                                </SkeletonTheme>
                                </div>
                                <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                    <Skeleton height={19} width={90}  borderRadius={10} inline={true} />
                                    </div>
                                        <div style={{ flex: 5}}>
                                            <Skeleton height={37} borderRadius={10} inline={true} />
                                        </div>
                                        <div style={{ flex: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                        </div>
                                    </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                        <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={19} width={110} borderRadius={10}  inline={true} />
                                        </div>
                                        <div style={{ flex: 5 }}>
                                            <Skeleton height={37} borderRadius={10} inline={true} />
                                        </div>
                                        <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                            <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                        </div>
                                    </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center" }}>
                                        <Skeleton height={19} width={90} borderRadius={10} inline={true} />
                                    </div>
                                            <div style={{ flex: 5 }}>
                                                <Skeleton height={37} borderRadius={10} inline={true} />
                                            </div>
                                            <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                                <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                            </div>
                                        </SkeletonTheme>
                                        </div>
                                        <div style={{display: "flex"}}>
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                    <Skeleton height={19} width={90}  borderRadius={10} inline={true} />
                                    </div>
                                <div style={{ flex: 5 }}>
                                    <Skeleton height={37} borderRadius={10} inline={true} />
                                </div>
                                <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                    <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                </div>
                            </SkeletonTheme>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <div style={{flex: 1, height: "fit-content", display: "flex", flexDirection: "column", rowGap: 20}}>
                <div className={classes.cardBox} style={{minWidth: 500}}>
                    <div className={classes.cardBoxHeader}>
                        <AttendanceDetailsIcon style={{width: 24, height: 24}}/>
                        <span role={TEXTBOX}>
                            {t("institution.attendanceSettings")}
                        </span>
                    </div>
                    <div className={classes.cardBoxBody}>
                        {!loading &&
                            <>
                                <span className={classes.cardDescription}>
                                    {t("institution.attendanceSettingsCardSubTitle")}
                                </span>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel} style={{whiteSpace: "nowrap"}}>
                                            {t("gradebook.geofencedLocationsTitle")}
                                        </div>
                                        <div className={classes.settingDescription}>
                                            {t("institution.attendanceSettingsGeoLocationSubTitle")}
                                        </div>
                                    </div>
                                    <div style={{flex: 1}}/>

                                    <YuJaButton style={{whiteSpace: "nowrap"}} onClick={() => setShowSavedLocationModal(true)}>
                                        {t("geofence.configureLocationsText")}
                                    </YuJaButton>
                                </div>
                            </>
                        }
                        {!!loading &&
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            marginTop: 20
                                        }}
                                    >
                                        <div style={{flex: 1}}>
                                            <div>
                                                <Skeleton height={19} width={100} borderRadius={10} inline={true}/>
                                            </div>
                                            <div style={{marginTop: 10}}>
                                                <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                            </div>
                                        </div>

                                        <Skeleton height={30} width={150} borderRadius={10} inline={true}/>
                                    </div>


                                </SkeletonTheme>
                            </div>
                        }

                    </div>
                </div>

                <div className={classes.cardBox} style={{minWidth: 500}}>
                    <div className={classes.cardBoxHeader}>
                        <API_ICON style={{width: 24, height: 24}}/>
                        <span role={TEXTBOX}>
                            {t("integration.evpIntegrationCardTitle")}
                        </span>
                    </div>
                    <div className={classes.cardBoxBody}>
                        {!loading &&
                            <>
                                <span className={classes.cardDescription}>
                                    {t("integration.evpIntegrationCardDescription")}
                                </span>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{t("integration.evpApiLinkLabel")}</div>
                                        <div className={classes.settingDescription}>{t("integration.evpApiLinkDesc")}</div>
                                    </div>
                                    <YuJaTextBox
                                        label={t("integration.lmsApiLinkLabel") + t("accessibility.textboxSuffix")}
                                        placeholder={t("integration.evpApiLinkPlaceholder")}
                                        name="lmsApiLink"
                                        value={platformSettings[PLATFORM_SETTINGS.PRIVATE_EVP_API_LINK]}
                                        containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, minWidth: 270}}
                                        onChange={(e) => {
                                            const copy = JSON.parse(JSON.stringify(platformSettings));
                                            copy[PLATFORM_SETTINGS.PRIVATE_EVP_API_LINK] = e.target.value;
                                            setPlatformSettings(copy);
                                        }}
                                    />
                                </div>

                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{t("integration.evpTokenLabel")}</div>
                                        <div className={classes.settingDescription}>{t("integration.evpTokenDesc")}</div>
                                    </div>
                                    <div style={{flex: 1}}/>
                                    <YuJaButton onClick={() => setOpenOverride(true)}>{t("common.override")}</YuJaButton>
                                </div>
                            </>
                        }
                        {!!loading &&
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            marginTop: 20
                                        }}
                                    >
                                        <div style={{flex: 1}}>
                                            <div>
                                                <Skeleton height={19} width={100} borderRadius={10} inline={true}/>
                                            </div>
                                            <div style={{marginTop: 10}}>
                                            <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                            </div>
                                        </div>

                                        <Skeleton height={30} width={150} borderRadius={10} inline={true}/>
                                    </div>


                                </SkeletonTheme>
                            </div>
                        }

                    </div>
                </div>
            </div>



            <OverrideModal
                show={openOverride}
                setModalShow={setOpenOverride}
                config={overwriteModalConfig}
                lmsType={t("integration.evpText")}
            />


        </>
    );
}